import React, { Component, PropTypes } from 'react';
import { pure } from 'recompose';
import OrderButtons from 'common/components/OrderButtons';

class ChapterHeader extends Component {
  static propTypes = {
    chapter: PropTypes.object.isRequired,
    chapterCount: PropTypes.number.isRequired,
    update: PropTypes.func.isRequired,
    moveUp: PropTypes.func.isRequired,
    moveDown: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onUpdate = this.onUpdate.bind(this);
    this.onMoveUp = this.onMoveUp.bind(this);
    this.onMoveDown = this.onMoveDown.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  onUpdate(e) {
    const name = e.target.value;
    this.props.update(this.props.chapter.id, name);
  }

  onMoveUp() {
    this.props.moveUp(this.props.chapter.id);
  }

  onMoveDown() {
    this.props.moveDown(this.props.chapter.id);
  }

  onRemove() {
    this.props.remove(this.props.chapter);
  }

  render() {
    const { chapter, chapterCount } = this.props;

    return (
      <div className="ui clearing segment">
        <div className="ui grid">
          <div className="left floated six wide column">
            <div className="ui fluid input">
              <input
                type="text"
                value={chapter.name}
                onChange={this.onUpdate}
              />
            </div>
          </div>
          <div className="right floated three wide column">
            <button
              className="ui right floated compact negative icon button"
              onClick={this.onRemove}
            >
              <i className="trash outline icon" />
            </button>
            <OrderButtons
              moveUp={this.onMoveUp}
              canMoveUp={chapter.order > 1}
              moveDown={this.onMoveDown}
              canMoveDown={chapter.order < chapterCount}
              mode="horizontal"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default pure(ChapterHeader);



// WEBPACK FOOTER //
// ./src/modules/memo/components/ChapterHeader.js